import React from 'react';
import 'babel-polyfill';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom';

import SignUpPage from './identity/SignUp';
import SignInPage from './identity/SignIn';
import ForgotPasswordPage from './identity/ForgotPassword';
import PasswordChangePage from './identity/PasswordChange';
import withAuthentication from './identity/withAuthentication';

import * as routes from '../config/routes';

import IntakeForm from './IntakeForm'
import ProposalForm from './ProposalForm'

import GetStarted from './GetStarted'

import WelcomeForm from './WelcomeForm'
import NotFound from './404'

import ErrorPage from './ErrorPage'
import SuccessPage from './SuccessPage'

import NewClient from './NewClient'
import AdminPage from './AdminOnly'



class App extends React.Component {

          // <Route exact path={routes.ADMIN}
          //   component={() => <AdminPage /> }
          // />

          // <Route exact path={routes.WELCOME}
          //   component={() => <WelcomeForm /> }
          // />



          // <Route exact path={routes.SIGN_UP}
          //   component={() => <SignUpPage /> }
          // />
          // <Route exact path={routes.SIGN_IN}
          //   component={() => <SignInPage /> }
          // />
          // <Route exact path={routes.PASSWORD_FORGET}
          //   component={() => <ForgotPasswordPage />}
          // />
          // <Route exact path={routes.PASSWORD_RESET}
          //   component={() => <PasswordChangePage />}
          // />
  render() {
    return (
      <Router>
        <div className="App">
        <Switch>
          <Route exact path={routes.BLANK}
            component={() => <GetStarted /> }
          />
          <Route exact path={routes.ERROR}
            component={ErrorPage}
          />
          <Route exact path={routes.SUCCESS}
            component={SuccessPage}
          />
          <Route exact path={routes.NEW}
            component={NewClient}
          />

          <Route component={NotFound} />
        </Switch>
        </div>

      </Router>
    );
  }
}


export default withAuthentication(App);


// WEBPACK FOOTER //
// ./src/components/App.js